import React, { FC } from 'react';

import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';

import { pharmacistActions, successOrSelector } from '@pharmaplan/common';

import useBookingReport from '../../../hooks/Invoice/useBookingReport';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { resetDialog } from '../../../reducers/dialogReducer';
import strings from '../../../localization';
import { Constants } from '../../../helpers/Constants';

import CustomButton from '../../common/CustomButton';
import DynamicTable from '../../DynamicTable';

import BookingReportHeader from './BookingReportHeader';
import styles from './styles';

interface IBookingReport {
  pharmacyId: string;
  isAutoSyncRecord?: boolean;
}

const BookingReport: FC<IBookingReport> = ({
  pharmacyId,
  isAutoSyncRecord,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    order,
    orderBy,
    handleSorting,
    handlePagination,
    page,
    table,
    totalCount,
    selectAll,
    handleSelectAll,
    data,
    selectedIds,
  } = useBookingReport(pharmacyId, isAutoSyncRecord);

  const loadSuccess = useAppSelector((state) =>
    successOrSelector([pharmacistActions.reports], state));

  const goToInvoice = () => {
    navigate(Constants.paths.generateInvoice, {
      state: { bookingIds: selectedIds, isAutoSyncRecord },
    });
    dispatch(resetDialog());
  };

  return (
    <>
      <BookingReportHeader
        selectAll={selectAll}
        handleSelectAll={handleSelectAll({ data, idProperty: 'id' })}
      />
      <Box sx={styles.tableContainer}>
        <DynamicTable
          table={table}
          loadSuccess={loadSuccess}
          totalCount={totalCount}
          page={page}
          order={order}
          orderBy={orderBy}
          handleSort={handleSorting}
          handlePagination={handlePagination}
          showHeader={false}
          stickyHeader
        />
      </Box>
      <Box sx={styles.buttonContainer}>
        <CustomButton
          label={strings.generateInvoice}
          disabled={!selectedIds.length}
          onClick={goToInvoice}
        />
      </Box>
    </>
  );
};

export default BookingReport;
